import FreeHand from "./FreeHand";
import RectangleOutlinedIcon from "@mui/icons-material/RectangleOutlined";
import {createBox} from "ol/interaction/Draw";

class Rectangle extends FreeHand {
	id = "Rectangle";
	name = "Rectangle";
	type = "Circle";
	icon = <RectangleOutlinedIcon/>;
	freehand = false;
	className = "Rectangle-forTour"
	geometryFunction = createBox();
	shortcutKey = "5";
}

export default Rectangle;
